import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';
import { UserInterface } from '../interfaces/user.interface';
import { AlertService } from 'src/app/shared/services/alert.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
})
export class LoginComponent implements OnInit {
  public formGroupLogin: UntypedFormGroup;
  public errorMessage: string;

  constructor(
    private readonly alertService: AlertService,
    private readonly router: Router,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly authService: AuthService
  ) {}

  public ngOnInit(): void {
    this.createLoginForm();
  }
  private createLoginForm(): void {
    this.formGroupLogin = this.formBuilder.group({
      email: ['', [Validators.email, Validators.required]],
      password: ['', Validators.required],
    });
  }

  public signIn(): void {
    const email = this.formGroupLogin.get('email').value;
    const password = this.formGroupLogin.get('password').value;
    this.authService
      .signIn(email, password)
      .then((user: UserInterface) => {
        let errorTitle: string;
        let errorMessage: string;
        if (user == null) {
          errorTitle = 'Usuario no encontrado';
          errorMessage = 'Por favor hable con el administrador';
        } else if (!user.emailVerified) {
          errorTitle = 'Usuario no verificado';
          errorMessage = 'Por favor verifique su cuenta';
        } else if (!user.active) {
          errorTitle = 'Usuario no activo';
          errorMessage = 'Por favor hable con el administrador';
        }

        if (errorTitle && errorMessage) {
          this.alertService.error({
            title: errorTitle,
            message: errorMessage,
          });
          return;
        }

        this.router.navigate(['/medias']);
      })
      .catch((err: { code: string; message: string }): void => {
        this.alertService.error({
          title: 'Error al iniciar sesión',
          message: `Credenciales incorrectas: ${err.message}`,
        });
      });
  }
}
